// frontend/src/services/api.js

export function getApiBase() {
  const envApi = process.env.REACT_APP_API_BASE && process.env.REACT_APP_API_BASE.trim();
  if (envApi) return envApi.replace(/\/$/, '');
  if (process.env.NODE_ENV === 'production') {
    return window.location.origin;
  }
  const hostname = (typeof window !== 'undefined' && window.location && window.location.hostname) || 'localhost';
  const port = 10000; // локальний порт бекенда
  return `http://${hostname}:${port}`;
}

const API_BASE = getApiBase();

export async function apiRequest(path, { method = 'GET', body, headers = {} } = {}) {
  const url = `${API_BASE}${path}`;
  const init = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
    credentials: 'include',
    // Избегаем 304 для динамических API, всегда берём свежие данные
    cache: 'no-store',
  };
  
  const res = await fetch(url, init);
  const isJson = res.headers.get('content-type')?.includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : await res.text();
  
  if (!res.ok) {
    // Покращена обробка помилок
    let errorMessage = `HTTP ${res.status}`;
    let errorCode = null;
    
    if (isJson && data) {
      // Отримуємо повідомлення з різних можливих полів
      errorMessage = data.message || data.error || errorMessage;
      errorCode = data.code || null;
      
      // Спеціальні повідомлення для різних статусів
      if (res.status === 422) {
        errorMessage = data.message || 'Невірні дані. Перевірте введену інформацію';
      } else if (res.status === 429) {
        errorMessage = 'Забагато спроб. Спробуйте через кілька хвилин';
      } else if (res.status === 409) {
        errorMessage = data.message || 'Це ім\'я користувача вже зайняте';
      } else if (res.status === 401) {
        errorMessage = data.message || 'Невірний логін або пароль';
      }
    }
    
    const error = new Error(errorMessage);
    error.status = res.status;
    error.code = errorCode;
    error.response = data;
    throw error;
  }
  
  return data;
}

export const api = {
  postRecommendations(userId, { limit = 20, sources = [] } = {}) {
    return apiRequest(`/api/user/${encodeURIComponent(userId)}/recommendations`, {
      method: 'POST',
      body: { limit, sources },
    });
  },
  // Инжест API: получить каталог трендов (для fallback)
  getIngestCatalog({ top } = {}) {
  const params = new URLSearchParams();
  if (top) params.set('top', String(top));
  // Добавляем метку времени для bust cache даже при прокси/ETag
  params.set('_', String(Date.now()));
  const q = params.toString() ? `?${params.toString()}` : '';
  return apiRequest(`/api/ingest/catalog${q}`);
  }
};

export default api;